import { type FunctionComponent, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { summaryLiveArticleSummaryLiveContent$key } from "scmp-app/queries/__generated__/summaryLiveArticleSummaryLiveContent.graphql";

import { Container, Header, StyledLiveArticleSummaryItem } from "./styles";

type Props = {
  className?: string;
  reference: summaryLiveArticleSummaryLiveContent$key;
};

export const LiveArticleSummary: FunctionComponent<Props> = ({ className, reference }) => {
  const contents = useFragment(
    graphql`
      fragment summaryLiveArticleSummaryLiveContent on LiveContent @relay(plural: true) {
        customTime
        entityUuid
        summary {
          text
        }
        ...itemLiveArticleSummaryLiveContent
      }
    `,
    reference,
  );

  const liveContents = useMemo(
    () =>
      contents
        ?.filter(content => notEmpty(content?.summary?.text))
        ?.toSorted((a, b) => (b?.customTime ?? 0) - (a?.customTime ?? 0)) ?? [],
    [contents],
  );

  if (liveContents.length === 0) return null;

  return (
    <Container className={className}>
      <Header>highlights</Header>
      {liveContents.map((liveContent, index) => (
        <StyledLiveArticleSummaryItem
          key={liveContent.entityUuid ?? index}
          reference={liveContent}
        />
      ))}
    </Container>
  );
};

LiveArticleSummary.displayName = "LiveArticleSummary";
